import React from 'react';
import { FilePlus2, Package, Boxes } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const InventoryToolbar = ({ onCreateLog, isCreating }) => {
    const navigate = useNavigate();

    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <Boxes size={18} className="me-2" />
                        <h5 className="mb-0">Cased Goods Inventory</h5>
                    </div>
                    
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-outline-secondary d-flex align-items-center"
                            onClick={() => navigate('/material-inventory')}
                        >
                            <Package size={18} className="me-2" />
                            Material Inventory
                        </button>

                        {/* Existing New Inventory button */}
                        <button
                            className="btn btn-outline-primary d-flex align-items-center"
                            onClick={onCreateLog}
                            disabled={isCreating}
                        >
                            <FilePlus2 size={18} className="me-2" />
                            {isCreating ? 'Creating...' : 'New Inventory'}
                        </button>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default InventoryToolbar;